import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight, Shield, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-slate-900 overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1485230405346-71acb9518d9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGd1YXJkfGVufDB8fHx8MTc2ODg5MjgxN3ww&ixlib=rb-4.1.0&q=85')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/95 to-slate-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[calc(100vh-200px)]">
          {/* Left Column */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/30 rounded-full px-4 py-2">
              <Shield className="w-4 h-4 text-orange-400" />
              <span className="text-orange-400 text-sm font-medium">{companyInfo.tagline}</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              {companyInfo.name.split(' ').slice(0, 2).join(' ')}{' '}
              <span className="text-orange-500">
                {companyInfo.name.split(' ').slice(2).join(' ') || 'Solutions'}
              </span>
            </h1>

            <p className="text-xl text-gray-300 leading-relaxed max-w-xl">
              {companyInfo.description}
            </p>

            {/* Features */}
            <div className="flex flex-wrap gap-4">
              {['Licensed & Insured', 'Nationwide Coverage', '24/7 Available'].map((feature) => (
                <div key={feature} className="flex items-center gap-2 text-gray-300">
                  <CheckCircle className="w-5 h-5 text-orange-500" />
                  <span className="text-sm font-medium">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <a 
                href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
                className="inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all hover:shadow-lg hover:shadow-orange-500/25 group"
              >
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </a>
              <Link 
                to="/contact"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all border border-white/20 group"
              >
                GET A FREE QUOTE
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>

          {/* Right Column - Quote Box */}
          <div className="hidden lg:block">
            <div className="bg-slate-800/80 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-white mb-2">Get the security services you need</h3>
              <p className="text-gray-400 mb-6">We're open 24/7. Call now for a quote!</p>
              
              <div className="space-y-4">
                <a 
                  href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
                  className="flex items-center justify-center gap-3 w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-lg font-bold text-xl transition-all"
                >
                  <Phone className="w-6 h-6" />
                  Call Now To Get Started
                </a>
                <p className="text-center text-gray-400 text-2xl font-bold">{companyInfo.phone}</p>
              </div>

              {/* Trust Badges */}
              <div className="mt-8 pt-6 border-t border-slate-700">
                <p className="text-sm text-gray-500 text-center mb-4">Trusted by Fortune 500 Companies</p>
                <div className="flex justify-center gap-6 opacity-50">
                  {['Burlington', 'La Quinta', 'Fendi Casa'].map((brand) => (
                    <span key={brand} className="text-white text-sm font-semibold">{brand}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 100V50C240 16.67 480 0 720 0C960 0 1200 16.67 1440 50V100H0Z" fill="#0f172a"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;